import { ComponentInstall } from "../../utils";
import Collapse from "./src";

export default ComponentInstall(Collapse);
